/**
 * Admin Login Page
 */
import { useAuth } from '@mzanzi/auth'
import { adminAuthOptions } from '@/auth'
import { Shield } from 'lucide-react'

export function LoginPage() {
  const { login, isLoading } = useAuth(adminAuthOptions)

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="mx-auto w-full max-w-sm space-y-6 rounded-lg border bg-card p-8 shadow-lg">
        <div className="flex flex-col items-center gap-2 text-center">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
            <Shield className="h-6 w-6 text-primary" />
          </div>
          <h1 className="text-2xl font-bold">Mzanzi Admin</h1>
          <p className="text-sm text-muted-foreground">
            Sign in with your staff account to access the admin portal.
          </p>
        </div>

        <button
          onClick={() => void login()}
          disabled={isLoading}
          className="flex w-full items-center justify-center gap-2 rounded-md bg-primary px-4 py-2.5 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90 disabled:opacity-50"
        >
          {isLoading ? (
            <>
              <div className="h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" />
              Signing in...
            </>
          ) : (
            'Sign in with Microsoft'
          )}
        </button>

        <p className="text-center text-xs text-muted-foreground">
          Staff accounts only. Unauthorized access will be denied.
        </p>
      </div>
    </div>
  )
}
